"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PrimaryButton", {
  enumerable: true,
  get: function get() {
    return _primaryButton.PrimaryButton;
  }
});
Object.defineProperty(exports, "PrimaryButtonLink", {
  enumerable: true,
  get: function get() {
    return _primaryButton.PrimaryButtonLink;
  }
});
Object.defineProperty(exports, "SecondaryButton", {
  enumerable: true,
  get: function get() {
    return _secondaryButton.SecondaryButton;
  }
});
Object.defineProperty(exports, "SecondaryButtonLink", {
  enumerable: true,
  get: function get() {
    return _secondaryButton.SecondaryButtonLink;
  }
});
Object.defineProperty(exports, "TertiaryButton", {
  enumerable: true,
  get: function get() {
    return _tertiaryButton.TertiaryButton;
  }
});
Object.defineProperty(exports, "TertiaryButtonLink", {
  enumerable: true,
  get: function get() {
    return _tertiaryButton.TertiaryButtonLink;
  }
});
var _primaryButton = require("./primary-button");
var _secondaryButton = require("./secondary-button");
var _tertiaryButton = require("./tertiary-button");